import React,{ FC, useMemo } from "react"
import { welfare_introduce1, welfare_introduce2, welfare_introduce3, welfare_rule1, welfare_rule2, welfare_rule3 } from "~src/constants/network"
import { WelfareMoldTyp } from "~src/service/welfare/welfare"
import styles from "./index.module.less"

enum WelfareSeatType {
  "INTRODUCE" = "introduce",
  "RULE" = "rule"
}
interface WelfareInfoType {
    backgroundImage: string,
}

type WelfareInfoRecordType = Record<WelfareSeatType, WelfareInfoType>

type WelfarePositions=Record<WelfareMoldTyp,WelfareInfoRecordType>

interface WelfareTitleProps {
  type:WelfareMoldTyp
  seat?: WelfareSeatType
}
const WelfareTitle: FC<WelfareTitleProps> = ({type, seat }) => {
  const WelfarePosition:WelfarePositions= useMemo(() => {
   return {
      "1": {
        [WelfareSeatType.INTRODUCE]: {
          backgroundImage: welfare_introduce2,
        },
        [WelfareSeatType.RULE]: {
          backgroundImage: welfare_rule2,
        }
      },
      "2": {
        [WelfareSeatType.INTRODUCE]: {
          backgroundImage: welfare_introduce1,
        },
        [WelfareSeatType.RULE]: {
          backgroundImage: welfare_rule1,
        }
      },
      "3": {
        [WelfareSeatType.INTRODUCE]: {
          backgroundImage: welfare_introduce3,
        },
        [WelfareSeatType.RULE]: {
          backgroundImage: welfare_rule3,
        }
      }
    }
  }, [])
  return <div className={styles.title}>
    {
      type&&seat &&
      <img className={styles["title-img"]} src={WelfarePosition[type][seat]?.backgroundImage} alt="" />
    }
  </div>
}
export default WelfareTitle
